
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Junior Developer 
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-graduation-cap"></i>
              <div class="text para_cls">
                <h3>Qualification & Experience: </h3>
                <p> <span class="step_no">1</span>Regular B. Tech or BSC or MSc or MCA or M. Tech degree in Computer Science, IT with Minimum 1+ years of experience in a web development field.</p>
               
              
  
              </div>
            </div>
          </div>
          <!-- feature box close -->
  
       
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Preferred:</h3>
        <p> <span class="step_no">1</span> Experience designing and implementing software systems in JavaScript, PHP, Laravel, including experience designing SaaS solutions and services. </p>
		<p> <span class="step_no">2</span> Hands on experience in core PHP/ Laravel. </p>		
       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Technologies:</h3>
        <p> <span class="step_no">1</span> Core PHP, LARAVEL, Angular. </p>
		<p> <span class="step_no">2</span> Web Development: HTML5, CSS3, JavaScript, SASS/LESS, jQuery, Bootstrap Web Services: REST, SOAP             </p>
        <p> <span class="step_no">3</span> Application Design: Model-View-Controller (MVC/MVC2), Object Oriented </p>
		<p> <span class="step_no">4</span> Programming, RESTful web services  Database: MySQL, Mongo DB  </p>
        <p> <span class="step_no">5</span> Experience working with agile methodologies. </p>
       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> <span class="step_no">1</span> Rs. 35,000/- per month  (consolidated pay) from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits.  </p>


      </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Responsibilities:</h3>
        <p> <span class="step_no">1</span>Deliver clean, attractive, and permanent website/ web app / mobile app solutions that match or exceed user expectations  </p>
        <p> <span class="step_no">2</span>Perform a mix of maintenance, enhancements, and new development as required  </p>
        <p> <span class="step_no">3</span>Work in a data analyst role and with business intelligence applications  </p>
        <p> <span class="step_no">4</span>Document features, technical specifications & infrastructure responsibilities  </p>
        <p> <span class="step_no">5</span>Work cross-functionally to convert business needs into technical specifications </p>


      </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Skills & Requirements:</h3>
        <p> <span class="step_no">1</span>1+ years of PHP, CodeIgniter, Laravel and MySQL  </p>
        <p> <span class="step_no">2</span> In-depth experience of PHP7 and PHP build tools, core PHP, JavaScript, jQuery, MVC Based coding, MySQL, HTML5, CSS3, XML </p>
        <p> <span class="step_no">3</span>PHP micro frameworks experience (Lumen / Laravel).  </p>
        <p> <span class="step_no">4</span>Familiarity with React JS, Angular is a plus.</p>
        <p> <span class="step_no">5</span>MySQL profiling and query optimization </p>
        <p> <span class="step_no">6</span>Object-oriented application building experience in a professional Agile/Scrum environment </p>
        <p> <span class="step_no">7</span>Experience with Sass and/or Less </p>
        <p> <span class="step_no">8</span>Understanding of User Interface workflows </p>
        <p> <span class="step_no">9</span>Excellent communication skills and being able to work independently or in a full team </p>
        <p> <span class="step_no">10</span>Experience of micro-service architecture and design best practices is essential </p>
        <p> <span class="step_no">11</span>Excellent Restful API authoring and design skills </p>
        <p> <span class="step_no">12</span>Good knowledge of development tools including Git, Composer and Jira </p>
        <p> <span class="step_no">13</span>Knowledge in database design and data modelling </p>


      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 22nd November 2021 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
        <p><span class="step_no">1</span>Chennai</p>
	
		
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee.</p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
<p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  
     <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
		<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority. </p>


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
   <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card</p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates</p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  
<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
